import { dataArrowUpSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowUpSolid = /*#__PURE__*/createIcon(dataArrowUpSolid)
export default IconArrowUpSolid
